/* global attachEvent, VideoPlayer */
// *******************************************************************************
// 1.0 - Embed Video
// *******************************************************************************

attachEvent('.video__poster,.video__play-button', 'click', (ev) => {
  const parentElem = ev.target.closest('.video__wrapper');
  VideoPlayer(parentElem);
});
